import React from 'react';
import styled from 'styled-components';
import { UserQuestionData } from '../types/MessageData';
import { MessageDebugInfo } from './MessageDebugInfo';

const UserMessageDiv = styled.div`
    position: relative;
    background-color: #CCE6D6;
    border-radius: 24px;
    padding: 8px 20px;
    font-size: 16px;
    width: fit-content;
    display: flex;
    align-self: flex-end;
    max-width: 70%;
    @media (max-width: 768px) {
        margin-bottom: 30px; max-width: 80%;
    }
`
const TopicDiv = styled.div`
    padding: 8px 20px;
    font-size: 12px;
    width: fit-content;
    display: flex;
    align-self: flex-end;
    max-width: 70%;
    @media (max-width: 768px) {
        margin-bottom: 30px; max-width: 80%;
    }
`
const Copy = styled.div`
    position: absolute;
    right: 2px;
    top: 0px;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 16px;

    &:hover {
        background: #bed7c8;
    }
`
type UserMessageProps = {
    message: UserQuestionData;
};

export const UserMessage: React.FC<UserMessageProps> = ({ message }) => {
    const onClick = () => {
        window.open(`${window.location.origin}?q=${message.content}`)
    }
    
    return (
        <>
            <UserMessageDiv>
                {message.content}
                <Copy title="Neues Fenster mit dieser Frage" onClick={onClick} />
                <MessageDebugInfo message={message} />
            </UserMessageDiv>
            {message.topic &&
                <TopicDiv>{message.topic}</TopicDiv>
            }
        </>
    )
}